import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { Topbar } from '@/components/Topbar';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Dashboard } from '@/routes/Dashboard';
import { Sources } from '@/routes/Sources';
import { Live } from '@/routes/Live';
import { Redaction } from '@/routes/Redaction';
import { Analysis } from '@/routes/Analysis';
import { Chat } from '@/routes/Chat';
import { SettingsPage } from '@/routes/Settings';
import Warehouse from '@/routes/Warehouse';
export default function App() {
    return (_jsxs(_Fragment, { children: [_jsx(Sidebar, {}), _jsxs("div", { className: "main-wrap", children: [_jsx(Topbar, {}), _jsx("main", { className: "content", children: _jsx(ErrorBoundary, { children: _jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/sources", element: _jsx(Sources, {}) }), _jsx(Route, { path: "/live", element: _jsx(Live, {}) }), _jsx(Route, { path: "/redaction", element: _jsx(Redaction, {}) }), _jsx(Route, { path: "/analysis", element: _jsx(Analysis, {}) }), _jsx(Route, { path: "/chat", element: _jsx(Chat, {}) }), _jsx(Route, { path: "/warehouse", element: _jsx(Warehouse, {}) }), _jsx(Route, { path: "/settings", element: _jsx(SettingsPage, {}) })] }) }) })] })] }));
}
